module.exports = __webpack_public_path__ + "static/media/covi_phy_exc_zon.77f8ffe6.png";